/* eslint-disable camelcase */
import Vue from 'vue'
import { API } from '@/api'
import freight_coupon_unavailable from '@/images/coupon_center/freight_coupon_unavailable.png'
import freight_coupon from '@/images/coupon_center/freight_coupon.png'
import time_service_coupon from '@/images/coupon_center/time_service_coupon.png'
import time_service_unuse from '@/images/coupon_center/time_service_unuse.png'
import shop from '@/images/coupon_center/shop.png'
import shop_invalid from '@/images/coupon_center/shop_invalid.png'

import { COUPON_TYPE } from '@/utils/enum'
const couponStatusText = {
  1: '领取',
  2: '已领取',
  3: '已抢光',
  4: '去使用',
  5: '已使用'
}
// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  props: {
    coupon: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    couponStatus() {
      return this.coupon?.actionStatus || this.coupon?.couponStatus
    },
    couponType() {
      return this.coupon?.couponType
    },
    couponText() {
      return couponStatusText[this.couponStatus]
    },
    // 可领取
    canReceive() {
      return this.couponStatus === 1
    },
    // 已领不在使用时间内
    notInDate() {
      return this.couponStatus === 2
    },
    // 已抢光
    outSale() {
      return this.couponStatus === 3
    },
    // 已领可使用
    canUse() {
      return this.couponStatus === 4
    },
    // 已使用
    hasUsed() {
      return this.couponStatus === 5
    },
    // 店铺劵
    isPop() {
      return this.coupon?.isShopCoupon === 1
    },
    couponTag() {
      if (this.isPop) {
        return this.outSale ? shop_invalid : shop
      }
      if (this.couponType === COUPON_TYPE.NEW_FREIGHT_COUPON) {
        return this.outSale ? freight_coupon_unavailable : freight_coupon
      }
      if (this.couponType === COUPON_TYPE.TIME_SERVICE_COUPON) {
        return this.outSale ? time_service_unuse : time_service_coupon
      }

      return null
    },
    // 店铺劵
    isSingProduct() {
      return this.coupon?.couponType === 6
    },
    invalidCoupon() {
      return this.outSale || this.hasUsed
    }
  },
  methods: {
    handleBtn() {
      if (this.canReceive) {
        this.receive()
      } else {
        this.goUse()
      }
    },
    /**
     * 领劵
     */
    async receive() {
      this.receiveTracer && this.receiveTracer()
      try {
        const res = await API.coupon.receiveCouponInCouponCenter({
          action_id: this.coupon.actionId
        })
        if (res) {
          this.$emit('updateCouponStatus', {
            index: this.index,
            couponStatus: res.receivedCouponStatus,
            amount: res.amount,
            remain: res.remain,
            effectiveDesc: res.effectiveDesc
          })
        }
        if (res.receivedCouponStatus === 3) {
          this.$toast('优惠卷已被抢光啦')
        } else {
          this.$toast('领取成功')
        }
      } catch (error) {
        this.$catch(error)
      }
    },
    /**
     * 去使用
     */
    goUse() {
      this.goUseTracer && this.goUseTracer()
      if (!this.coupon.jumpUrl) return
      this.$autoRedirect(this.coupon.jumpUrl)
    }
  }
})
